import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

interface IParagraphDescriptionProps {
  text: string;
}

export const ParagraphDescription: React.VFC<IParagraphDescriptionProps> = ({ text }) => (
  <UIText2 as="p" color="gray60_100">
    {text}
  </UIText2>
);
